// В.2.d-2: Медик-штурмовик (liv_medik_shturmovik, rare, 1/2/3).
// Приказ при выставлении: «Уничтожь до 2 своих юнитов на поле, получи их
// суммарную atk и current_hp».
//
// Picker (multi-select):
//   - Кандидаты: свои юниты на поле, кроме самого Медика-штурмовика.
//   - Игрок выбирает 0, 1 или 2 юнита. 0 = пропуск (Приказ без жертв,
//     Медик без бонуса).
//   - Подтверждение через «OK».
//
// Эффект:
//   1. Снимок: для каждой жертвы — current.atk и current.hp.
//   2. destroyUnit для каждой (полноценная смерть → on_unit_died: Реаниматор
//      сработает за каждую, собственные Посмертия жертв сработают и т.д.).
//   3. applyPermanentBuff(self, {atk: суммарная_atk, hp: суммарная_hp}).
//      По правилу проекта +N hp = +N max_hp + синхронный +N current_hp.
//
// Бот: автовыбор — пропуск (0 жертв). Это нормально для текущего бота.

import { applyPermanentBuff } from '../../buffs.js';
import { dispatchUnitDied } from '../deus/hooks.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_medik_shturmovik';
const LABEL = 'Медик-штурмовик';
const MAX_SACRIFICES = 2;

registerImplementedAbility(CARD_ID, 'order');

export function medikShturmovikCandidates(state, ownerIdx, medik) {
  const me = state.players?.[ownerIdx];
  if (!me) return [];
  return me.unitsOnField().filter(u =>
    u.type === 'unit' && u !== medik && u.instanceId !== medik?.instanceId
  );
}

function findOwnUnitByInstanceId(state, ownerIdx, instanceId) {
  if (instanceId == null) return null;
  const me = state.players?.[ownerIdx];
  if (!me) return null;
  for (const u of me.unitsOnField()) {
    if (u.instanceId === instanceId) return u;
  }
  return null;
}

// opts.sacrificeInstanceIds — массив instanceId до 2 элементов.
//   - undefined / нет ключа → бот: пропуск (0 жертв).
//   - [] → пропуск.
//   - [id1, id2?] → жертвы.
export function medikShturmovikOrder(state, ownerIdx, medik, opts = {}) {
  if (!medik || !medik.isAlive()) return;
  if (medik.current?.silenced) return;
  const me = state.players?.[ownerIdx];
  if (!me) return;

  const ids = Array.isArray(opts.sacrificeInstanceIds)
    ? opts.sacrificeInstanceIds.slice(0, MAX_SACRIFICES)
    : [];

  if (ids.length === 0) {
    state.log?.add(`🩸 ${LABEL} [${me.name}]: без жертвы`);
    return;
  }

  // Снять снимок и провалидировать целей.
  const sacrifices = [];
  let totalAtk = 0;
  let totalHp = 0;
  const seen = new Set();
  for (const id of ids) {
    if (seen.has(id)) continue; // дубль защищаемся
    seen.add(id);
    const u = findOwnUnitByInstanceId(state, ownerIdx, id);
    if (!u) continue;
    if (u === medik || u.instanceId === medik.instanceId) continue;
    if (u.type !== 'unit') continue;
    sacrifices.push({
      card: u,
      atk: u.current?.atk ?? 0,
      hp: u.current?.hp ?? 0
    });
  }
  if (sacrifices.length === 0) {
    state.log?.add(`🩸 ${LABEL} [${me.name}]: цели недоступны — без жертвы`);
    return;
  }

  // Уничтожаем каждую жертву через стандартный путь смерти.
  for (const s of sacrifices) {
    totalAtk += s.atk;
    totalHp += s.hp;
    s.card.current.hp = 0;
    s.card.alive = false;
    me.removeFromField(s.card);
    state.log?.add(`✗ ${s.card.name_ru} [${me.name}] уничтожен Медиком-штурмовиком`);
    dispatchUnitDied(state, {
      ownerIdx, card: s.card, killer: medik, killerIdx: ownerIdx, killerWasCounter: false
    });
  }

  // Бафф: +totalAtk/0/+totalHp.
  applyPermanentBuff(state, medik, { atk: totalAtk, armor: 0, hp: totalHp }, CARD_ID, LABEL);

  const names = sacrifices.map(s => s.card.name_ru).join(', ');
  state.log?.add(
    `🩸 ${LABEL} [${me.name}]: жертва ${names} → +${totalAtk}/0/${totalHp}`
  );
}
